var map = {
	"./arrow-with-stem.svg": 277,
	"./calendar.svg": 7799,
	"./close.svg": 9023,
	"./cluster.svg": 7757,
	"./crown.svg": 4614,
	"./email.svg": 6023,
	"./grid.svg": 8577,
	"./patreon.svg": 2180,
	"./pinpoint.svg": 2136,
	"./play.svg": 7335,
	"./selectedCluster.svg": 5384,
	"./social-media/facebook.svg": 3114,
	"./social-media/instagram.svg": 4366,
	"./social-media/twitter.svg": 71,
	"./trophy.svg": 9491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8289;